

















































import { mapState } from "vuex";
import { gsap } from "gsap";
import J05ChatScreenPanelMessage from "@/general/components/pages/parts/ThanksPointMessage/J05ChatScreenPanelMessage.vue";
import J05ChatScreenPanelMessageBody from "@/general/components/pages/parts/ThanksPointMessage/J05ChatScreenPanelMessageBody.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
import * as dayjs from "dayjs";
import * as isLeapYear from "dayjs/plugin/isLeapYear"; // import plugin;
import "dayjs/locale/zh-cn"; // import locale
import utc from "dayjs/plugin/utc";

// dayjs.extend(LocalizedFormat);
dayjs.extend(utc);

@Component({
  components: {
    J05ChatScreenPanelMessage,
    J05ChatScreenPanelMessageBody
  },
  directives: {
    scroll(el: any, binding: any) {
      const f = function(evt: any) {
        if (binding.value(evt, el)) {
          window.removeEventListener("scroll", f);
        }
      };
      window.addEventListener("scroll", f);
    }
  }
})
export default class J05ChatScreenPanel extends Vue {
  @Prop({ type: Object, required: true }) chatData!: any;
  @Prop({ type: Number, required: true }) unreadKeyNo!: number;

  isSp = globals.isSpScreenWidth;
  myId = commons.userInfo.id;
  date = "";
  shownDate = true;
  classNameDirection = {
    true: "--r",
    false: "--l"
  };

  shownUnreadLabel = () => {
    return this.key == this.unreadKeyNo ? true : false;
  };
  // shownUnreadLabel = () => {
  //   return false;
  //   const key = this.chatData;
  //   const prevUnreadLabel =
  //     key > 0 ? this.chatData.chatLog[key - 1].unread : "";
  //   return prevUnreadLabel === false && this.chatData.unread;
  // };

  get chatLog() {
    return this.chatData.chatLog;
  }

  get unread() {
    return this.chatData.unread;
  }

  get key() {
    return this.chatData.key;
  }

  get internalShownUnreadLabel() {
    return this.shownUnreadLabel;
  }

  set internalShownUnreadLabel(newValue) {
    if (this.shownUnreadLabel !== newValue) {
      this.shownUnreadLabel = newValue;
    }
  }

  get isYouSent() {
    return this.chatData.isYouSent;
  }

  get message() {
    return this.chatData.message;
  }

  get title() {
    return this.chatData.title;
  }

  created() {
    this.formattedDate();
    this.initShownDate();
  }

  formattedDate() {
    const date = this.chatData.date;
    // console.log("inner " + date);

    this.date = dayjs.utc(date).format("YYYY/M/D(ddd)");
    // console.log("this" + this.date);
  }

  initShownDate() {
    const key = this.chatData.key;
    const prevDate = key > 0 ? this.chatData.chatLog[key - 1].date : "";
    const currentDate = this.chatData.date;

    if (prevDate === "") {
      this.shownDate = true;
      return false;
    }

    const prevLocalDate = dayjs.utc(prevDate).local();
    const currentLocalDate = dayjs.utc(currentDate).local();

    const formattedPrevDate = prevLocalDate.format("YYMMDD");
    const formattedCurrentDate = currentLocalDate.format("YYMMDD");

    const difference = formattedPrevDate !== formattedCurrentDate;
    this.shownDate = difference;

    return true;
  }
  handleScroll(evt: any, el: any) {
    const functions = this.handleScrollFunctions(evt, el);
    const inTheWindow = functions.inTheWindow();

    if (inTheWindow) {
      functions.animationFadeOutLabel(inTheWindow);
    }
  }

  handleScrollFunctions(evt: any, el: any) {
    const functions = {
      inTheWindow() {
        const internalShownUnreadLabel = false;

        if (internalShownUnreadLabel === false) {
          return false;
        }

        const elPosition = el.getBoundingClientRect().top;
        const inTheWindow = elPosition < window.innerHeight - 100;

        return inTheWindow;
      },

      animationFadeOutLabel(inTheWindow: any) {
        const marginTop = (num: any) => `${num / 16}rem`;

        gsap.to(el, 0.2, {
          delay: 0.4,
          autoAlpha: 0,
          height: 0,
          marginTop: marginTop(-16),

          onComplete() {
            setTimeout(() => {
              this.internalShownUnreadLabel = !inTheWindow;
            }, 800);
          }
        });
      }
    };

    return functions;
  }
}
